import { jsx as l } from "react/jsx-runtime";
const a = (e) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16",
    ...e,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.5 6.5a2.5 2.5 0 1 0-2.458-2.04l-3.29 1.756a2.5 2.5 0 1 0 0 3.568l3.29 1.755a2.5 2.5 0 1 0 .706-1.323L6.459 8.46a2.514 2.514 0 0 0 0-.922l3.29-1.755c.452.443 1.07.716 1.752.716Zm0-1.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0 8a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM5 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  a as Share
};
